module.exports = __webpack_public_path__ + "bab0688dd83b4ca4bf8a54c6cb0ddf53.svg";